"use client";
import { useState } from "react";
import { ModalBody, ModalFooter } from "react-bootstrap";
import Btn from "../ui/button/Btn";
import withModal from "./withModal";

const ConfirmModalInner = ({
  onClose,
  onConfirm,
  message = "Are you sure you want to delete this item?",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <ModalBody>
        <p
          className="delete-message mb-4"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </ModalBody>

      <ModalFooter className="gap-8">
        <Btn
          variant="cancel"
          title={cancelText}
          onClick={onClose}
          size="modal"
          disabled={isDeleting}
        />

        <Btn
          type="submit"
          variant="danger"
          title={confirmText}
          size="modal"
          onClick={handleConfirm}
          disabled={isDeleting}
        />
      </ModalFooter>
    </>
  );
};

const ConfirmModal = withModal(ConfirmModalInner);
export default ConfirmModal;
